/* eslint-disable import/prefer-default-export */
import axios, { AxiosResponse } from 'axios'
import { getShop, getShopLocale } from '@helpers/env'
import { Carriers, ReturnsOrder, ReturnsProduct } from './types'

// eslint-disable-next-line prefer-destructuring
const RETURNS_API_DOMAIN = process.env.RETURNS_API_DOMAIN
const SHOP = getShop()
const REQUEST_HEADERS = {
  headers: {
    'x-api-key': process.env.RETURNS_API_KEY
  }
}

type GetOrderDataArgs = {
  order_name: string
  postcode: string
  admin: boolean
}
export function getOrderData(
  requestBody: GetOrderDataArgs
): Promise<ReturnsOrder> {
  const requestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}/order?order_name=${
    requestBody.order_name
  }&postcode=${requestBody.postcode}${requestBody.admin ? '&admin=true' : ''}`

  return axios.get(requestUrl, REQUEST_HEADERS).then(({ data }) => data.order)
}

export async function getCarriersAvailable(
  orderNumber: string
): Promise<Carriers> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}/carrier-services?order_number=${orderNumber}&country=${getShopLocale()}`
  const { data } = await axios.get(reboundRequestUrl, REQUEST_HEADERS)

  if (data.error) {
    throw new Error(data.error)
  }

  if (!data.carriers?.length) {
    throw new Error('No carriers returned')
  }

  return data.carriers
}

type SaveReturnDataArgs = {
  products: ReturnsProduct[]
  order_number: string
  postcode: string
}
type SaveReturnDataResponse = {
  return_id: string
}
export function saveReturnData(
  requestBody: SaveReturnDataArgs
): Promise<AxiosResponse<SaveReturnDataResponse>> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}`
  return axios.post(reboundRequestUrl, requestBody, REQUEST_HEADERS)
}

type CreateReturnArgs = {
  returnId: string
  serviceId: number
  collectionDate?: string
}
type CreateReturnResponse = {
  label: string
  encoding: string
}
export function createReturn({
  returnId,
  serviceId,
  collectionDate
}: CreateReturnArgs): Promise<AxiosResponse<CreateReturnResponse>> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}/create`
  const reboundBody = {
    return_id: returnId,
    service_id: serviceId,
    ...(collectionDate && { collection_date: collectionDate })
  }
  return axios.post(reboundRequestUrl, reboundBody, REQUEST_HEADERS)
}

type GetReturnLabelResponse = {
  labelUrl: string
}
export function getReturnLabel(
  returnId: string,
  labelFormat = ''
): Promise<AxiosResponse<GetReturnLabelResponse>> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/${SHOP}/label/${returnId}?label_format=${labelFormat}`
  return axios.get(reboundRequestUrl, REQUEST_HEADERS)
}

type GetReturnStatusResponse = {
  status?: {
    date: string
  }
  error?: {
    message: string
  }
}
export function getReturnStatus(): Promise<
  AxiosResponse<GetReturnStatusResponse>
> {
  const reboundRequestUrl = `${RETURNS_API_DOMAIN}/return/status`
  const res = axios.get(reboundRequestUrl, REQUEST_HEADERS)
  return res
}
